<template>
    <section class="section-hero section-shaped my-0">
        <div class="shape shape-style-1 shape-primary">
            <!-- <span class="span-150"></span>
            <span class="span-50"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-100"></span>
            <span class="span-75"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
            <span class="span-50"></span>
            <span class="span-100"></span> -->
            <div class="hero-hover"></div>
        </div>
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-9 text-center pt-lg hero-text">
                        <!-- <img src="//memx-website.oss-cn-shanghai.aliyuncs.com/img/brand/white.png" style="width: 300px;" class="img-fluid"> -->
                        <!-- <p class="text-white mt-4 subtitle font-weight-bold">Interactive Visual Intelligence</p> -->
                        <p class="text-white mt-4 subtitle font-weight-bold">MemX: Embodied AGI</p> 
                        <p class="lead text-white mt-4 mb-5 subsubtitle">From AGI Companions to Digital Immortality</p>
                        <!-- <p class="text-white mt-4 mb-5 subsubtitle">Eyes are the window to the soul</p> -->
                        <!-- <p class="text-white mt-4 mb-5 subsubtitle">Intelligent Human-Computer Interaction Lab</p> -->
                        <!-- <p class="lead text-white mt-4 mb-5 subsubtitle">MemX, in the form of smart glasses, unifies human vision with computer vision, advancing the human-centered computing pathway from human perception, emotion, cognition, and more, toward artificial general intelligence.</p> -->
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
</style>
